module.exports = __webpack_public_path__ + "img/8.14f2ea15.gif";